/* import __COLOCATED_TEMPLATE__ from './history.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();